import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'

const NoNotifications = () =>
  <div className='flex flex-col gap-2 items-center'>
    <Header
      hasNoTopMargin
      rank={4}
    >
      No notifications
    </Header>
    <Paragraph>
      <Color variant='theme-description-text'>
        Add email or webhook notifications to receive updates of your tests.
      </Color>
    </Paragraph>
  </div>

export default NoNotifications
